import { fontFamilyMap, headerScaleMap } from "./constants";
import { resolveWidgetDimensions } from "./positioning";

export const themeStylesFromConfig = (config) => {
  const viewportWidth =
    typeof window === "undefined" ? 0 : window.innerWidth;
  const viewportHeight =
    typeof window === "undefined" ? 0 : window.innerHeight;
  const { width, height } = resolveWidgetDimensions(
    config,
    viewportWidth,
    viewportHeight,
  );

  return {
    "--bb-page-bg": config.styles.page_bg,
    "--bb-btn-color": config.styles.btn_color,
    "--bb-footer-bg": config.styles.footer_bg,
    "--bb-header-bg": config.styles.header_bg,
    "--bb-icon-color": config.styles.icon_color,
    "--bb-link-color": config.styles.link_color,
    "--bb-input-color": config.styles.input_color,
    "--bb-bot-bg": config.styles.bot_tb_color,
    "--bb-bot-text": config.styles.bot_txt_color,
    "--bb-user-bg": config.styles.sender_tb_color,
    "--bb-user-text": config.styles.sender_txt_color,
    "--bb-input-bg": config.styles.input_box_color,
    "--bb-option-bg": config.styles.option_tb_color,
    "--bb-option-text": config.styles.option_txt_color,
    "--bb-border-bot": config.styles.bot_border_color,
    "--bb-border-user": config.styles.sender_border_color,
    "--bb-button-text": config.styles.btn_txt_color,
    "--bb-body-font": fontFamilyMap[config.fontBody] || fontFamilyMap.Arial,
    "--bb-title-scale":
      headerScaleMap[config.fontHeader] || headerScaleMap.Medium,
    "--bb-widget-width": `${width}px`,
    "--bb-widget-height": `${height}px`,
  };
};
